import { Edit } from '@mui/icons-material'
import CloseIcon from '@mui/icons-material/Close'
import { Button, IconButton, TextField } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
// import { LocalizationProvider, MobileTimePicker } from '@mui/x-date-pickers'
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import 'dayjs/locale/de'
import utc from 'dayjs/plugin/utc'
import React, { useState } from 'react'
import ApiService from '../../../../ApiService'
import { useStates } from '../../../../StateProvider'
import { TRIP_STOPS_UPDATE_WAIT_TIME_URL } from '../../../../constants'
import '../../../../scss/gps.scss'
import './timePicker.css'

// FIXME: The waitTime is in milliseconds from UTC 00:00:00, so it has to be converted to the local time when viewing Time Picker/ Edit Mode!.
function EditableWaitingTimeComponent(props) {
  const { showToast } = useStates()
  dayjs.extend(utc)

  const waitTimeInMilliseconds = props.waitTime
  console.log(
    'EditableWaitingTimeComponent waitTimeInMilliseconds : ',
    waitTimeInMilliseconds
  )

  const [timeValue, setTimeValue] = useState({
    timeInMilliseconds: waitTimeInMilliseconds,
    hours: Math.floor(waitTimeInMilliseconds / (1000 * 60 * 60)),
    mins: Math.floor((waitTimeInMilliseconds / (1000 * 60)) % 60),
    timeInDayJs: dayjs(new Date(waitTimeInMilliseconds).toISOString())
  })

  const [isEditing, setIsEditing] = useState(false)
  const [confirmStopWaitTime, setConfirmStopWaitTime] = useState(false)

  const [humanReadableTime, setHumanReadableTime] = useState(() => {
    // const date = new Date(waitTimeInMilliseconds).toISOString()
    // return dayjs(date).utc().format('HH:mm')

    const totalMinutes = Math.floor(waitTimeInMilliseconds / 1000 / 60)
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
  })

  const handleCancelClick = () => {
    setIsEditing(false)
  }

  const handleClose = () => {
    setConfirmStopWaitTime(false)
  }

  const handleApplyClick = async () => {
    // request on window for confirmation
    // if yes, update Stop Time
    // if no, do nothing and close the edit mode
    if (
      timeValue.timeInMilliseconds === waitTimeInMilliseconds ||
      props.connectedEmulatorId === null ||
      props.tripPointIndex === null
    ) {
      // console.log(
      //   'No change in wait time or connectedEmulatorId or tripPointIndex is null. Returning...'
      // )
      setIsEditing(false)
      return
    }

    // const shouldUpdateTime = window.confirm(
    //   'Are you sure you want to update the stop wait time to ' +
    //     timeValue.timeInDayJs.utc().format('HH') +
    //     ' hours and ' +
    //     timeValue.timeInDayJs.utc().format('mm') +
    //     ' minutes?'
    // )
    // if (!shouldUpdateTime) {
    //   return
    // }
    showToast('Updating Wait Time...', 'info')
    const token = localStorage.getItem('token')
    const { success, error } = await ApiService.makeApiCall(
      TRIP_STOPS_UPDATE_WAIT_TIME_URL,
      'GET',
      null,
      token,
      props.connectedEmulatorId,
      new URLSearchParams({
        stopTripPointIndex: props.tripPointIndex,
        newWaitTime: timeValue.timeInMilliseconds
      })
    )

    if (!success) {
      showToast(error, 'error')
      console.error('handleApplyClick error : ', error)
    } else {
      showToast('Stop Wait Time Updated!', 'success')
      // const date = new Date(timeValue.timeInMilliseconds)
      // const hours1 = date.getUTCHours()
      // const minutes2 = date.getUTCMinutes()
      // const humanReadableTime =
      //   hours1.toString().padStart(2, '0') +
      //   ':' +
      //   minutes2.toString().padStart(2, '0')
      const hoursStr = timeValue.hours.toString().padStart(2, '0')
      const minsStr = timeValue.mins.toString().padStart(2, '0')
      const humanReadableTime = `${hoursStr}:${minsStr}`
      setHumanReadableTime(humanReadableTime)
      props.handleClose()
    }
    setIsEditing(false)
    setConfirmStopWaitTime(false)
  }

  // const handleTimeChange = (value) => {
  //   console.log('handleTimeChange value : ', value.unix() * 1000)
  //   const utcMilliseconds = dayjs(value).utc().valueOf()
  //   setTimeValue({
  //     timeInMilliseconds: value.unix() * 1000,
  //     timeInDayJs: dayjs.utc(utcMilliseconds)
  //   })
  // }

  // const handleIncrement = () => {
  //   // if value greater than 24 hours, return
  //   if (timeValue.timeInMilliseconds + 1800000 > 86400000) {
  //     return
  //   }
  //   const newTimeInMilliseconds = timeValue.timeInMilliseconds + 1800000

  //   setTimeValue({
  //     timeInMilliseconds: newTimeInMilliseconds,
  //     timeInDayJs: dayjs(new Date(newTimeInMilliseconds).toISOString())
  //   })
  // }

  // const handleDecrement = () => {
  //   // if value less than 0, return
  //   if (timeValue.timeInMilliseconds - 1800000 < 0) {
  //     return
  //   }
  //   const newTimeInMilliseconds = timeValue.timeInMilliseconds - 1800000
  //   setTimeValue({
  //     timeInMilliseconds: newTimeInMilliseconds,
  //     timeInDayJs: dayjs(new Date(newTimeInMilliseconds).toISOString())
  //   })
  // }

  return (
    <div>
      <h6 className="align-stop-wait-time-stops">Stop wait Time </h6>
      {isEditing ? (
        <>
          {/* <div style={{ display: 'flex', alignItems: 'center' }}>
            <button
              style={{
                width: '20px',
                height: '25px'
              }}
              onClick={handleDecrement}
            >
              -
            </button>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
              <MobileTimePicker
                label="wait time"
                ampm={false}
                timezone="UTC"
                value={timeValue.timeInDayJs}
                onChange={handleTimeChange}
                ToolbarComponent={() => <></>}
              />
            </LocalizationProvider>
            <button style={{ height: '25px' }} onClick={handleIncrement}>
              +
            </button>
          </div> */}
          <div className="d-flex gap-2 ">
            <TextField
              label="Hours"
              type="number"
              inputProps={{ min: 0, max: 300 }}
              value={timeValue.hours}
              onChange={(e) => {
                let newHours = Number(e.target.value)
                if (newHours > 300) newHours = 300
                const newMillis = (newHours * 60 + timeValue.mins) * 60 * 1000
                setTimeValue((prev) => ({
                  ...prev,
                  hours: newHours,
                  timeInMilliseconds: newMillis
                }))
              }}
            />

            <TextField
              label="Minutes"
              type="number"
              inputProps={{ min: 0, max: 59 }}
              value={timeValue.mins}
              onChange={(e) => {
                let newMins = Number(e.target.value)
                if (newMins > 59) newMins = 59
                const newMillis = (timeValue.hours * 60 + newMins) * 60 * 1000
                setTimeValue((prev) => ({
                  ...prev,
                  mins: newMins,
                  timeInMilliseconds: newMillis
                }))
              }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-evenly',
              marginTop: '14px'
            }}
          >
            <Button
              variant="contained"
              size="small"
              className="stop-wait-time-cancel"
              onClick={handleCancelClick}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              size="small"
              className="stop-wait-time-apply"
              onClick={() => setConfirmStopWaitTime(!confirmStopWaitTime)}
            >
              Apply
            </Button>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              gap: '3rem'
            }}
          >
            <p className="pt-2 stop-wait-time-data">
              {humanReadableTime} hours
            </p>
            <IconButton
              aria-label="edit"
              onClick={() => setIsEditing(true)}
              size="small"
              disabled={props.currentTripPointIndex > props.tripPointIndex}
            >
              <Edit fontSize='small' style={{ marginBottom: '10px' }} />
            </IconButton>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'right',
              marginTop: '14px'
            }}
          >
            <Button
              variant="contained"
              size="small"
              className="stops-delete-btn"
              onClick={() => props.handleDeleteStop()}
              disabled={props.currentTripPointIndex > props.tripPointIndex}
            >
              Delete
            </Button>
            {/* <Button
              variant="contained"
              size="small"
              sx={{ marginLeft: '10px' }}
              onClick={() => props.handleClose()}
            >
              Close
            </Button> */}
          </div>
        </>
      )}

      {/* Confirmation to change Stop wait time */}
      <Dialog
        open={confirmStopWaitTime}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-description-title">
          Update stop wait time
          {/* Close Button */}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: '#00000'
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description-desc">
            {'Are you sure you want to update the stop wait time to ' +
              timeValue.hours +
              ' hours and ' +
              timeValue.mins +
              ' minutes?'}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            size="small"
            className="stops-create-btn-modal"
            onClick={handleApplyClick}
            autoFocus
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default EditableWaitingTimeComponent
